/*
  Campaign: 카운트다운 바
  sections/campaign-sticky-countdown-bar.liquid 전용 커스텀 엘리먼트.

  · 목표 일시는 '2026-10-10 00:00' 형식이며 항상 KST(+09:00)로 해석한다.
    해외에서 접속해도 같은 시점을 가리키도록 브라우저 로컬 타임존에 기대지 않는다.
  · 남은 시간은 전부 브라우저에서 계산한다. Shopify 는 스토어프론트 HTML 을
    엣지 캐시하므로 서버에서 렌더한 숫자는 옛 값이 그대로 나갈 수 있다.
  · 클라이언트 시계를 신뢰하는 구조다. 시계를 조작하면 다른 숫자가 보인다.
    실제 오픈/차단은 링크 도착지에서 처리해야 한다.
*/
if (!customElements.get('sticky-countdown-bar')) {
  customElements.define(
    'sticky-countdown-bar',
    class StickyCountdownBar extends HTMLElement {
      connectedCallback() {
        this.countdownEl = this.querySelector('[data-scb-countdown]');
        this.daysEl = this.querySelector('[data-scb-days]');
        this.timeEl = this.querySelector('[data-scb-time]');

        this.targetAt = this.toKstDate(this.dataset.targetAt);
        this.dayPrefix = this.dataset.dayPrefix || '';
        this.endBehavior = this.dataset.endBehavior || 'hide_countdown';
        this.endText = this.dataset.endText || '';

        this.showAfter = parseInt(this.dataset.showAfter, 10);
        if (isNaN(this.showAfter)) this.showAfter = 0;

        this.onScroll = this.onScroll.bind(this);
        this.tick = this.tick.bind(this);
        this.onToggle = this.onToggle.bind(this);

        this.setupVisibility();
        this.setupCountdown();
        this.setupToggle();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        if (this.timer) clearInterval(this.timer);
        if (this.toggleEl) this.toggleEl.removeEventListener('click', this.onToggle);
      }

      /* 모바일 '펼치기' 버튼. PC 에서는 버튼이 숨겨져 있어 눌릴 일이 없다. */
      setupToggle() {
        this.toggleEl = this.querySelector('[data-scb-toggle]');
        if (!this.toggleEl) return;
        this.toggleEl.addEventListener('click', this.onToggle);
      }

      onToggle() {
        var isOpen = this.classList.toggle('is-open');
        this.toggleEl.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }

      /* '2026-10-10 00:00' → KST 고정 Date. 비었거나 형식이 어긋나면 null. */
      toKstDate(value) {
        if (!value || !value.trim()) return null;
        const date = new Date(value.trim().replace(' ', 'T') + ':00+09:00');
        return isNaN(date.getTime()) ? null : date;
      }

      setupVisibility() {
        // 테마 편집기에서는 임계점과 무관하게 항상 보여준다.
        // 그러지 않으면 섹션을 추가해도 화면에 아무것도 안 나타나 고장으로 읽힌다.
        if (window.Shopify && window.Shopify.designMode) {
          this.classList.remove('is-hidden');
          return;
        }

        if (this.showAfter <= 0) {
          this.classList.remove('is-hidden');
          return;
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      onScroll() {
        if (this.rafPending) return;
        this.rafPending = true;

        requestAnimationFrame(() => {
          this.rafPending = false;
          // showAfter 는 화면 높이 대비 비율(%)이다.
          const threshold = (window.innerHeight * this.showAfter) / 100;
          this.classList.toggle('is-hidden', window.pageYOffset < threshold);
        });
      }

      setupCountdown() {
        if (!this.countdownEl) return;

        // 목표 일시가 없거나 형식이 어긋나면 카운트다운만 감추고 바는 유지한다.
        if (!this.targetAt) {
          this.countdownEl.hidden = true;
          return;
        }

        this.countdownEl.hidden = false;
        this.tick();
        this.timer = setInterval(this.tick, 1000);
      }

      tick() {
        const remain = this.targetAt.getTime() - Date.now();

        if (remain <= 0) {
          this.renderEnded();
          return;
        }

        const total = Math.floor(remain / 1000);
        const days = Math.floor(total / 86400);
        const hours = Math.floor((total % 86400) / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const seconds = total % 60;

        if (this.daysEl) this.daysEl.textContent = this.dayPrefix + days;
        if (this.timeEl) {
          this.timeEl.textContent = [hours, minutes, seconds].map(this.pad).join(':');
        }
      }

      renderEnded() {
        if (this.timer) clearInterval(this.timer);

        if (this.endBehavior === 'hide_bar') {
          this.classList.add('is-ended');
          return;
        }

        if (this.endBehavior === 'replace') {
          if (this.daysEl) this.daysEl.textContent = this.endText;
          if (this.timeEl) this.timeEl.textContent = '';
          return;
        }

        this.countdownEl.hidden = true;
      }

      pad(value) {
        return value < 10 ? '0' + value : String(value);
      }
    }
  );
}
